//if (stockno.substr(0, 1) === "7") 權證 略過
import { idNameItem, OpenWinLoadOption } from 'jk-service';
import { Injectable } from '@angular/core';
import { StkmaServicePkg } from './stkmaPkg.service';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class StkmaService extends StkmaServicePkg {
  public stockList: idNameItem[] = [];
  futureList: idNameItem[] = [];
  seaList: idNameItem[] = [];
  stockListReady: Subject<void> = new Subject<void>();
  constructor() {
    super();
    this.getIdNameList();
  }
  getIdNameList() {
    /*       this.idNameOpt.sqlSelect= `SELECT MA001 as id,MA002 as name,MA001+'-'+MA002 as idName,MA002+'-'+MA001 as nameId FROM STKMA`;
      this.idNameOpt.sqlWhere= ` AND MA020='N' `
      this.idNameOpt.sqlOrder= 'ORDER BY MA001';
      this.loadIdNameList(this.idNameOpt);
      */
    let r: OpenWinLoadOption = {
      mainTable: 'STKMA',
      item: 'S01',
      type: 'S',
      params: [],
      list: this.idNameList,
    };
    //orm.doOpenwinLoad(r);
    this.orm.doOpenwinLoadRx(r).subscribe({
      next: (value) => {
        this.idNameList = value.obj;
      },
      error: (error) => {
        alert(this.tableName + ' 載入錯誤:' + error.message);
      },
      complete: () => {
        if (this.idNameList) {
          this.stockList = this.idNameList.filter((item) => {
            if (item.ps1) {
              return item.ps1 <= '1';
            } else return false;
          });
          this.futureList = this.idNameList.filter((item) => {
            if (item.ps1) {
              return item.ps1 === '2';
            } else return false;
          });
          this.seaList = this.idNameList.filter((item) => {
            if (item.ps1) {
              return item.ps1 === 'O';
            } else return false;
          });
        }
        this.stockListReady.next();
        this.stockListReady.complete();
      },
    });
  }

  gotoKey(key: string): void {
    if(!key) return;
    if(!this.idNameList) return;

    if (this.idNameList.length === 0) {
      this.getIdNameList();
    }
    this.item = this.idNameList.find((item) => item.id === key);
    if (!this.item.id) {
      this.item = { id: '', name: '' };
    }
  }
  
  
}
